module.exports = __webpack_public_path__ + "static/media/bbb-food-menu1.a46c3f24.png";